<script lang="typescript">
    import TimeLine from "../../components/charts/timeline.svelte";
    import type { ExternalBar, Marks } from "../../components/charts/timeline";
    import SectionSubHeader from "../../components/section-subheader.svelte";
    import { RuleUtils } from "src/utils";
    export let bars: ExternalBar[] = [];
    export let marks: Marks[] = [];
    export let rule: Rule;
    export let conditions: RuleCondition[];
    export let name = "";
</script>

<div class="lookup-timeline">
    <SectionSubHeader title="Acessos do Colaborador: {name}" />
    {#if rule}
        <SectionSubHeader
            title="Algorítmo de Anomalia: {RuleUtils.getConditionName(
                rule.condition,
                conditions
            )}"
            color={RuleUtils.getConditionColor(rule.condition)}
        />

        {#if rule.condition === "DEVICE_TOLERANCE"}
            <SectionSubHeader
                title="Primeiro Dispositivo: {rule.deviceStart}"
                color={RuleUtils.getConditionColor(rule.condition)}
            />
            <SectionSubHeader
                title="Segundo Dispositivo: {rule.deviceEnd}"
                color={RuleUtils.getConditionColor(rule.condition)}
            />
            <SectionSubHeader
                title="Tolerância : {RuleUtils.getJorneySizeHour(
                    rule.deviceToleranceMinutes
                )}"
                color={RuleUtils.getConditionColor(rule.condition)}
            />
        {/if}

        {#if rule.condition !== "COMPOUND_ACCESS" && rule.condition !== "DEVICE_TOLERANCE"}
            <SectionSubHeader
                title="Dispositivo: {rule.device}"
                color={RuleUtils.getConditionColor(rule.condition)}
            />
        {/if}

        {#if rule.condition == "COMPOUND_ACCESS"}
            <div class="internal-rules">
                {#each rule.rules as internalRule}
                    <div class="internal-rule">
                        {#if internalRule.condition === "DEVICE_TOLERANCE"}
                            <SectionSubHeader
                                title="Primeiro Dispositivo: {internalRule.deviceStart}"
                                color={RuleUtils.getConditionColor(
                                    internalRule.condition
                                )}
                            />
                            <SectionSubHeader
                                title="Segundo Dispositivo: {internalRule.deviceEnd}"
                                color={RuleUtils.getConditionColor(
                                    internalRule.condition
                                )}
                            />
                        {:else}
                            <SectionSubHeader
                                title="Dispositivo: {internalRule.device}"
                                color={RuleUtils.getConditionColor(
                                    internalRule.condition
                                )}
                            />
                        {/if}

                        <SectionSubHeader
                            title="Description: {internalRule.description}"
                            color={RuleUtils.getConditionColor(
                                internalRule.condition
                            )}
                        />
                        <SectionSubHeader
                            title="Algorítmo de Anomalia: {RuleUtils.getConditionName(
                                internalRule.condition,
                                conditions
                            )}"
                            color={RuleUtils.getConditionColor(
                                internalRule.condition
                            )}
                        />
                    </div>
                {/each}
            </div>
        {/if}
    {/if}
    <TimeLine {bars} {marks} />
</div>

<style>
    .internal-rules {
        padding: 0 16px;
    }
    .internal-rule {
        padding: 8px 0;
    }

    .lookup-timeline {
        max-height: 800px;
        height: 800px;
        width: 1000px;
        overflow-y: auto;
        padding: 16px;
        display: flex;
        flex-direction: column;
    }
</style>
